import { useMentorships } from '../../../hooks/useMentorships';
import { VOUCH_COPY } from '../../../pages/Vouch/vouch.copy';
import { MentorshipRow } from './MentorshipRow';
import './MentorshipRoster.scss';

export function MentorshipRoster() {
  const enabled = import.meta.env.VITE_ENABLE_VOUCHING === 'true';
  const { mentorships, refetch } = useMentorships();
  if (!enabled) return null;
  const hasWindingDown = mentorships.some(
    (m) => m.status === 'ACTIVE' && Boolean(m.revokedAt),
  );
  return (
    <div className="mentorship-roster">
      <h3 className="mentorship-roster__title">Mentorships</h3>
      {mentorships.length === 0 ? (
        <p className="mentorship-roster__empty">
          You haven't vouched for anyone yet.
        </p>
      ) : (
        mentorships.map((m) => (
          <MentorshipRow
            key={m.vouchId}
            mentorship={m}
            onRevoked={() => refetch()}
          />
        ))
      )}
      {hasWindingDown && (
        <p className="mentorship-roster__note">
          {VOUCH_COPY.revokeWindingNote}
        </p>
      )}
    </div>
  );
}
